import { useState } from 'react';

import { Box, Divider, Flex, Image } from '@chakra-ui/react';
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@mesh.ai/rabbit';

import EventType from 'assets/assetsV1/illustrations/deerIllustrations/event_type.svg';
import TriggerCondition from 'assets/assetsV1/illustrations/deerIllustrations/trigger_condition.svg';

import { InputV2 } from 'uiToolkitV1/InputV2/InputV2';
import { TextBodyMedium } from 'uiToolkitV1/Typography';

const ContinuousReviewTrigger = () => {
  const [selectedEventType, setSelectedEventType] = useState<string>('Review result');
  return (
    <Card
      style={{
        background: '#FDFDFD',
      }}
    >
      <CardHeader>
        <CardTitle>Trigger</CardTitle>
        <Divider mt="8px" color="#EBEFF3" opacity={1} />
      </CardHeader>
      <CardContent>
        <Flex alignItems="center">
          <Image src={EventType as unknown as string} height="24px" width="24px" mr="4px" />
          <TextBodyMedium mr="16px" bold>
            Event type:
          </TextBodyMedium>
          <Select value={selectedEventType} onValueChange={(value) => setSelectedEventType(value)}>
            <SelectTrigger className="w-[180px]">
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              <SelectGroup>
                <SelectItem value="Review result">Review result</SelectItem>
                <SelectItem value="Date of joining">Date of joining</SelectItem>
              </SelectGroup>
            </SelectContent>
          </Select>
        </Flex>
        {selectedEventType === 'Review result' ? (
          <Flex alignItems="center" mt="8px">
            <Image src={TriggerCondition as unknown as string} height="24px" width="24px" mr="4px" />
            <TextBodyMedium bold mr="8px">
              Trigger condition:
            </TextBodyMedium>
            <TextBodyMedium mr="8px">Add to the review if</TextBodyMedium>
            <Select defaultValue="Final score">
              <SelectTrigger style={{ marginRight: '8px' }} className="w-[180px]">
                <SelectValue />
              </SelectTrigger>
              <SelectContent>
                <SelectGroup>
                  <SelectItem value="Final score">Final score</SelectItem>
                  <SelectItem value="Outcome">Outcome</SelectItem>
                  <SelectItem value="Grid Position">Grid Position</SelectItem>
                </SelectGroup>
              </SelectContent>
            </Select>
            <TextBodyMedium mr="8px">in</TextBodyMedium>
            <Select defaultValue="Annual Appraisal 2024">
              <SelectTrigger style={{ marginRight: '8px' }} className="w-[180px]">
                <SelectValue />
              </SelectTrigger>
              <SelectContent>
                <SelectGroup>
                  <SelectItem value="Mid year Performance Review 2023">Mid year Performance Review 2023</SelectItem>
                  <SelectItem value="Mid year Performance Review 2024">Mid year Performance Review 2024</SelectItem>
                  <SelectItem value="Annual Appraisal 2024">Annual Appraisal 2024</SelectItem>
                  <SelectItem value="Annual Appraisal 2023">Annual Appraisal 2023</SelectItem>
                </SelectGroup>
              </SelectContent>
            </Select>
            <TextBodyMedium mr="8px">is</TextBodyMedium>
            <Select defaultValue="Good">
              <SelectTrigger style={{ marginRight: '8px' }} className="w-[180px]">
                <SelectValue />
              </SelectTrigger>
              <SelectContent>
                <SelectGroup>
                  <SelectItem value="Poor">Poor</SelectItem>
                  <SelectItem value="Below Average">Below Average</SelectItem>
                  <SelectItem value="Average">Average</SelectItem>
                  <SelectItem value="Good">Good</SelectItem>
                  <SelectItem value="Above Average">Above Average</SelectItem>
                  <SelectItem value="Outstanding">Outstanding</SelectItem>
                </SelectGroup>
              </SelectContent>
            </Select>
          </Flex>
        ) : (
          <Flex alignItems="center" mt="8px">
            <Image src={TriggerCondition as unknown as string} height="24px" width="24px" mr="4px" />
            <TextBodyMedium bold mr="8px">
              Trigger condition:
            </TextBodyMedium>
            <TextBodyMedium mr="8px">Add to the review </TextBodyMedium>
            <Box w="32px">
              <InputV2 type="number" isDashed defaultValue="60" />
            </Box>
            <TextBodyMedium mr="8px">days post date of joining.</TextBodyMedium>
          </Flex>
        )}
      </CardContent>
    </Card>
  );
};

export { ContinuousReviewTrigger };
